import { useMatches } from 'react-router-dom';

const crumbOf = (match: any) => match?.handle?.crumb;

const useBreadcrumbs = () => {
  return useMatches().flatMap((match) =>
    crumbOf(match) ? [crumbOf(match) as Crumb] : [],
  );
};

export type Crumb = 'pathways' | 'scenario';

export { useBreadcrumbs };
